
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/passwordResetRequest",
      function () {
        return require("private-next-pages/app/passwordResetRequest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/passwordResetRequest"])
      });
    }
  